import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MyLearningPathQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyLearningPathQuery = { __typename?: 'Query', myLearningPath: Array<{ __typename?: 'LearningPath', pathId: string, module: Types.LearningModule, completedCount: number, totalCount: number, nextConceptId?: string | null, concepts: Array<{ __typename?: 'LearningConcept', conceptId: string, titleKey: string, summaryKey: string, docsPath: string, walkthroughId?: string | null, isComplete: boolean, milestone?: { __typename?: 'LearningMilestone', eventTypes: Array<string> } | null, progress: { __typename?: 'LearningConceptProgress', explainedAt?: Types.TDateISO | null, milestoneObservedAt?: Types.TDateISO | null } }> }> };

export type MyWalkthroughStateQueryVariables = Types.Exact<{
  walkthroughIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type MyWalkthroughStateQuery = { __typename?: 'Query', myWalkthroughState: Array<{ __typename?: 'LearningWalkthroughState', walkthroughId: string, offeredAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null }> };

export type LearningPathConceptFragment = { __typename?: 'LearningConcept', conceptId: string, titleKey: string, summaryKey: string, docsPath: string, walkthroughId?: string | null, isComplete: boolean, milestone?: { __typename?: 'LearningMilestone', eventTypes: Array<string> } | null, progress: { __typename?: 'LearningConceptProgress', explainedAt?: Types.TDateISO | null, milestoneObservedAt?: Types.TDateISO | null } };

export type LearningWalkthroughStateFragment = { __typename?: 'LearningWalkthroughState', walkthroughId: string, offeredAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null };

export const LearningPathConceptFragmentDoc = new TypedDocumentString(`
    fragment LearningPathConcept on LearningConcept {
  conceptId
  titleKey
  summaryKey
  docsPath
  walkthroughId
  isComplete
  milestone {
    eventTypes
  }
  progress {
    explainedAt
    milestoneObservedAt
  }
}
    `, {"fragmentName":"LearningPathConcept"});
export const LearningWalkthroughStateFragmentDoc = new TypedDocumentString(`
    fragment LearningWalkthroughState on LearningWalkthroughState {
  walkthroughId
  offeredAt
  dismissedAt
}
    `, {"fragmentName":"LearningWalkthroughState"});
export const MyLearningPathDocument = new TypedDocumentString(`
    query MyLearningPath {
  myLearningPath {
    pathId
    module
    completedCount
    totalCount
    nextConceptId
    concepts {
      ...LearningPathConcept
    }
  }
}
    fragment LearningPathConcept on LearningConcept {
  conceptId
  titleKey
  summaryKey
  docsPath
  walkthroughId
  isComplete
  milestone {
    eventTypes
  }
  progress {
    explainedAt
    milestoneObservedAt
  }
}`);
export const MyWalkthroughStateDocument = new TypedDocumentString(`
    query MyWalkthroughState($walkthroughIds: [String!]!) {
  myWalkthroughState(walkthroughIds: $walkthroughIds) {
    ...LearningWalkthroughState
  }
}
    fragment LearningWalkthroughState on LearningWalkthroughState {
  walkthroughId
  offeredAt
  dismissedAt
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    MyLearningPath: build.query<MyLearningPathQuery, MyLearningPathQueryVariables | void>({
      query: (variables) => ({ document: MyLearningPathDocument, variables })
    }),
    MyWalkthroughState: build.query<MyWalkthroughStateQuery, MyWalkthroughStateQueryVariables>({
      query: (variables) => ({ document: MyWalkthroughStateDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useMyLearningPathQuery, useLazyMyLearningPathQuery, useMyWalkthroughStateQuery, useLazyMyWalkthroughStateQuery } = injectedRtkApi;
